export const MAX_PER_CATEGORY = 5

export const MAX_NAME_LENGTH = 60

// Categories as an array (not an object) to keep snake_case only in string
// Values, never as identifiers — which the camelcase/quote-props lint rules forbid.
// Colors come from the backend `palette` prop (IssueStatus::PALETTE), not here.
export const CATEGORIES = [
  { value: 'to_do', label: 'Non résolue', labelPlural: 'Non résolues' },
  { value: 'in_progress', label: 'En cours', labelPlural: 'En cours' },
  { value: 'done', label: 'Résolue', labelPlural: 'Résolues' }
]

const categoryBy = value => CATEGORIES.find(category => category.value === value)

export const categoryLabel = value => categoryBy(value)?.label ?? value

export const categoryLabelForCount = (value, count) => {
  const category = categoryBy(value)
  if (!category)
    return value
  return count > 1 ? category.labelPlural : category.label
}

export const categoryBadgeVariant = value => {
  if (value === 'to_do')
    return 'danger'
  if (value === 'done')
    return 'success'
  return 'progress'
}

export const colorsForCategory = (palette, value) => palette?.[value] ?? []

// First palette color not already used in the category, so a new/moved status does
// Not repeat a colour; falls back to the first one when the palette is exhausted.
export const defaultColorForCategory = (palette, value, usedColors = []) => {
  const colors = colorsForCategory(palette, value)
  return colors.find(color => !usedColors.includes(color)) ?? colors[0] ?? null
}
